import React from "react";
import Arrow from "../arrow";
import styles from "./styles.css";
import PropTypes from "prop-types";

const IconChevronRipple = ({onClick}) => {
    return (
        <button className="rippleEffect" styleName={"styles.rippleBtn"} onClick = {onClick}>
            <Arrow grey={"GreyArrow"} rotateBy={180} />
        </button>
    );
};
IconChevronRipple.propTypes = {
    onClick: PropTypes.func
};

export default IconChevronRipple;
